import axios from 'axios';
import {
	ServiceUrls,
	RequestStatusKeys,
	RequestStatusMutationTypes
} from '@/modules/common';

export const GetFeedListAction = async ({ commit }) => {
	const requestStatus = RequestStatusKeys.FEED_LIST;
	commit(RequestStatusMutationTypes.LOADING, requestStatus);

	try {
		const response = await axios.get(ServiceUrls.FEED);

		let responseData = response.data || [];
		let responseMeta = {};
		if (responseData.length > 0) {
			if (responseData[0].meta != null) {
				responseMeta = responseData[0].meta;
			}
			
			if (responseData[0].data != null) {
				responseData = responseData[0].data;
			}
		}
		const payload = {
			requestStatus,
			data: {
				data: responseData,
				meta: responseMeta
			}
		};

		commit(RequestStatusMutationTypes.SUCCESS, payload);
	} catch (error) {
		const payload = {
			requestStatus,
			error
		};
		commit(RequestStatusMutationTypes.ERROR, payload);
	}
};